import React from 'react';
import styled from 'styled-components';
import { IconButton } from '@mui/material';
import { IrRate } from '../components';
import {  Edit as EditI } from '@mui/icons-material';

export const IrRatings = ({ data, reportId, handleOnPressRate }) => {
  const ratings = (data||[]);
  const half = Math.ceil(ratings.length / 2);
  const firstHalf = ratings.slice(0, half);
  const secondHalf = ratings.slice(half);

  return <Container>
    <Table>
      <Heading>
        <h2>Report Ratings</h2>
        <p>Below are the ratings related to this report.</p>
      </Heading>
      <TableRow>
        <div>
          {firstHalf.map((rate, i) => (
            <P>
              {rate.name}
              <Ib>
                <IrRate
                displayType={rate.display_type}
                onClick={(value) => handleOnPressRate(value, reportId, rate.id, i)}
                values={rate?.options?.values||[]}
                >
                  <EditI/>
                </IrRate>
              </Ib>
              <Sub>{rate.current_value||'(No rating selected)'}</Sub>
            </P>
          ))}
        </div>

        <div>
          {secondHalf.map((rate, i) => (
            <P>
              {rate.name}
              <Ib>
                <IrRate
                displayType={rate.display_type}
                onClick={(value) => handleOnPressRate(value, reportId, rate.id, i, true)}
                values={rate?.options?.values||[]}
                >
                  <EditI/>
                </IrRate>
              </Ib>
              <Sub>{rate.current_value||'(No rating selected)'}</Sub>
            </P>
          ))}
        </div>

      </TableRow>
    </Table>
  </Container>;
};

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const Table = styled.div`
  width: 100%;
  height: auto;
  min-height: 200px;
  background-color: #FFFFFF;
  border: solid 1px #ccd7e3;
  border-radius: 4px;
  padding-bottom: 20px; 
`;

const Heading = styled.div`
  padding: 20px;
  padding-bottom: 0px;
  h2 {
    color: #595959;
    font-size: 24px;
    font-weight: 700;
  }
  p {
    color: #595959;
    font-size: 14px;
    font-weight: 400;
  }
`;

const TableRow = styled.div`
  width: 100%;
  height: auto;
  padding: 20px;
  background-color: #f5f8fa;
  border-top: solid 1px #ccd7e3;
  border-bottom: solid 1px #ccd7e3;
  display: flex;
  flex-direction: row;
  div:nth-child(1) {
    flex: 1;
  }
  div:nth-child(2) {
    flex: 1;
  }
`;

const Ib = styled(IconButton).attrs({size: 'small'})`
  margin-left: 10px;
  margin-right: 10px;
`;

const P = styled.div``;

const Sub = styled.span`
  font-size: 0.8em;
  font-weight: bold;
`;